import { useEffect, useState } from 'react';

export const DEFAULT_PAGE_SIZE = 20;

const calculatePageCount = (itemCount: number, pageSize: number) =>
    Math.ceil(itemCount / pageSize);

export const usePagination = (
    itemCount: number,
    pageSize: number = DEFAULT_PAGE_SIZE
) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(
        calculatePageCount(itemCount, pageSize)
    );

    useEffect(() => {
        setPageCount(calculatePageCount(itemCount, pageSize));
    }, [itemCount, pageSize]);

    return {
        currentPage,
        setCurrentPage,
        pageCount
    };
};
